<template>
  <div>
    <label for="searchText">{{ prop.title }}&nbsp;&nbsp;</label>

    <input
      class="form-control-sm"
      type="text"
      id="searchText"
      :value="modelValue"
      @input="updateValue($event.target.value)"
    />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const prop = defineProps({
  modelValue: {
    type: String,
  },
  title: { type: String, default: 'Search' },
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (newValue) => {
  emit('update:modelValue', newValue);
};
</script>
